"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE = 'active';
exports.ENABLED = 'enabled';
exports.DISABLED = 'disabled';
exports.COMING_SOON = 'comingsoon';
const CREATED = 'created';
exports.CREATED = CREATED;
const APPROVED = 'approved';
exports.APPROVED = APPROVED;
const DISAPPROVED = 'disapproved';
exports.DISAPPROVED = DISAPPROVED;
const SCHEDULED = 'scheduled';
exports.SCHEDULED = SCHEDULED;
const RUNNING = 'running';
exports.RUNNING = RUNNING;
const STOPPED = 'stopped';
exports.STOPPED = STOPPED;
const FINISHED = 'finished';
exports.FINISHED = FINISHED;
const statuses = [CREATED, APPROVED, DISAPPROVED, SCHEDULED, RUNNING, STOPPED, FINISHED];
exports.statuses = statuses;
const runnableStatuses = [SCHEDULED, RUNNING];
exports.runnableStatuses = runnableStatuses;
const notRunnableStatuses = [CREATED, APPROVED, DISAPPROVED, FINISHED, STOPPED];
exports.notRunnableStatuses = notRunnableStatuses;
//# sourceMappingURL=status.js.map